export enum ControlerEnum {
  Vehicle = 'vehicle',
  Metadata = 'metadata',
  Offer = 'offer',
  User = 'user',
  Calculation = 'calculation',
  Country = 'country',
}
